import React from "react";
import {
  BrowserRouter as Router,
  Routes as Switch,
  Route,
} from "react-router-dom";
import { Footer, Header } from "../components";
import * as Pages from "../pages";

const Routes = () => {
  return (
    <>
      <Router>
          <Header />
        <Switch>
          <Route path="/" element={<Pages.Home />} />
          <Route path="/about" element={<Pages.About />} />
          <Route path="/contact" element={<Pages.Contact />} />
          <Route path="/help" element={<Pages.Help />} />
          <Route path="/Iniciativas" element={<Pages.Iniciativas />} />
          <Route path="/doacao" element={<Pages.Doacao />} />
          <Route path="/eventos" element={<Pages.Eventos />} />
          <Route
            path="*"
            element={
              <>
                <h1> Got LOST?? </h1>
              </>
            }
          />
        </Switch>
        <Footer />
      </Router>
    </>
  );
};

export default Routes;
